import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-heart',
  templateUrl: './icon-heart.component.html',
  styleUrls: ['./icon-heart.component.scss']
})
export class IconHeartComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;
  
  constructor() { }

  ngOnInit() {
  }

}
